import { useState } from 'react';
import { PaginationCustom } from '@/components/common';
import { Filters } from '@/components/dashboard/cases/Filters';
import { CasesGrid } from './CasesGrid';
import { CasesGridMobile } from './CasesGridMobile';

export const MyCasesDashboardScreen: React.FC = () => {
	const [total, setTotal] = useState<number>();
	const [totalItems, setTotalItems] = useState<number>();
	const [totalPages, setTotalPages] = useState<number>();

	return (
		<>
			<div className="space-y-6 w-full flex flex-col lg:h-full lg:min-h-0">
				<Filters
					total={total}
					totalItems={totalItems}
					paramLimit={1}
					sizeText="regular-14"
				/>
				<CasesGridMobile
					setTotal={setTotal}
					setTotalItems={setTotalItems}
					setTotalPages={setTotalPages}
				/>
				<div className="hidden lg:flex space-y-6 w-full h-full flex-col">
					<CasesGrid
						setTotal={setTotal}
						setTotalItems={setTotalItems}
						setTotalPages={setTotalPages}
					/>
					{totalPages && totalPages > 1 ? (
						<PaginationCustom className="!pb-6" totalPages={totalPages} />
					) : null}
				</div>
			</div>
		</>
	);
};
